angular.module('jv.Admin.Users')
    .controller('AdminEmployeeImport', ['$scope', 'adminUserSVC',
        function($scope, adminUserSVC) {
            $scope.importConfirmation = false;
            $scope.importEmployees = function() {
                var postData = {
                    GUID: $scope.GUID,
                    fileName: $scope.fileName
                };
                $scope.flags.loading = true;
                adminUserSVC.importEmployees(postData, function(response) {
                    $scope.flags.loading = false;
                    if (response.Status === 200) {
                        $scope.importConfirmation = true;
                    }
                });
            };
            $scope.hideImportModal = function() {
                $scope.importModal.show = false;
            };
        }]);


